export class Tag {
    id: string;
    name: string;
    code: string;
    nameCode: string;
    shortName: string;
    children: Array<Tag> = [];
    taggable: boolean;
    appliesToClients: boolean;
    appliesToAssessments: boolean;
    appliesToStaff: boolean;
    appliesToOrgUnits: boolean;
    toBeDeleted: boolean;
    root: boolean;

    constructor(tag: any) {
        if (tag) {
            this.id = tag.id;
            this.name = tag.name;
            this.code = tag.code;
            this.nameCode = tag.nameCode;
            this.shortName = tag.shortName;
            this.taggable = tag.taggable;
            this.appliesToClients = tag.appliesToClients;
            this.appliesToAssessments = tag.appliesToAssessments;
            this.appliesToStaff = tag.appliesToStaff;
            this.appliesToOrgUnits = tag.appliesToOrgUnits;
            this.toBeDeleted = tag.toBeDeleted;
            if (tag.children) {
                tag.children.forEach((tag) => {
                    this.children.push(new Tag(tag));
                });
            }
        }
    }
}